import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-xsqg",
  "use": "icon-xsqg-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-xsqg\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 962c-248.52832031 0-450-201.47167969-450-450S263.47167969 62 512 62s450 201.47167969 450 450-201.47167969 450-450 450z m155.25-346.83398438L550.671875 526.0625V259.74511719c0-21.35742188-17.31445313-38.671875-38.671875-38.671875s-38.671875 17.31445313-38.671875 38.671875v304.47949219l146.92675781 112.5c17.05957031 12.84960938 41.30859375 9.44824219 54.15820313-7.61132813 12.71777344-16.88378906 9.52734375-40.8515625-7.16308594-53.81542969v-0.13183593z\" p-id=\"10694\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/xsqg.svg
// module id = R43A
// module chunks = 16